module.exports = __webpack_public_path__ + "img/ro.83853d7f.svg";